export const { REACT_APP_STORAGE_TYPE } = process.env;
export const { REACT_APP_SERVER_URL } = process.env;
export const { REACT_APP_PICTURE_API_KEY } = process.env;
export const { REACT_APP_DESKTOP_MODE_MINIMUM_WIDTH } = process.env;
export const REACT_APP_PROD = process.env.REACT_APP_PROD === 'true';
